import { TextVariantType } from "../../theme/types";

export const TextStylesByVariant: TextVariantType = {
    heading1: {
        fontSize: "48px",
        fontWeight: 600,
    },
    heading2: {
        fontSize: "32px",
        fontWeight: 600,
    },
    heading3: {
        fontSize: "24px",
        fontWeight: 600,
    },
    heading4: {
        fontSize: "20px",
        fontWeight: 600,
    },
    heading5: {
        fontSize: "18px",
        fontWeight: 600,
    },
    heading6: {
        fontSize: "16px",
        fontWeight: 600,
    },
    body1: {
        fontSize: "16px",
        fontWeight: 400,
    },
    body2: {
        fontSize: "14px",
        fontWeight: 400,
    },
    body3: {
        fontSize: "12px",
        fontWeight: 500,
    },
    button1: {
        fontSize: "14px",
        fontWeight: 600,
    },
    button2: {
        fontSize: "12px",
        fontWeight: 600,
    },
    label: {
        fontSize: "14px",
        fontWeight: 600,
    },
    error: {
        fontSize: "9px",
        fontWeight: 500,
    },
};
